<script setup>
import {computed, ref, watch} from "vue";
import { trans } from 'laravel-vue-i18n';
import EditTimeSlotComponent from "../../../components/ui-components/EditTimeSlotComponent.vue";
import CalendarBasedTimeSlot from "../../../components/ui-components/time-slot/CalendarBasedTimeSlot.vue";
import PlanCalendar from "../../../components/ui-components/time-slot/PlanCalendar.vue";

const emit = defineEmits(['done'])

const model = defineModel();
const deleted = defineModel('deleted', [])
const valid = defineModel('valid')
const selectedPlan = ref('default')
const selectedWorker = ref(null)

const computedSelected = computed(() => {
    if (selectedPlan.value === 'default') {
        return 0;
    }
    return selectedPlan.value;
})

const previousSelected = ref(0);

const animationName = computed(() => {
    if (previousSelected.value === 0 && computedSelected.value > 0) {
        return 'slide-left';
    } else if (previousSelected.value > 0 && computedSelected.value === 0) {
        return 'slide-right';
    } else if (previousSelected.value > 0 && computedSelected.value > 0) {
        return 'fade';
    }
    return 'fade';
});

watch(computedSelected, (newVal, oldVal) => {
    previousSelected.value = oldVal;
});

watch(model, (now) => {
    valid.value = now.timeSlots.length > 0 && now.timeSlots[computedSelected.value].type !== 'vacation' ? (Object.values(now.timeSlots[computedSelected.value].days).map((el) => el.timeslots).filter(el => el.length && el.filter(tim => tim.time_start && tim.time_end).length).length) : true;
}, {immediate: true, deep: true})

const addDaySlot = () => {
    const daysTemplate = {
        valid: {
            from: null,
            to: null
        },
        type: 'regular',
        days: {
            mon: {
                id: 'mon',
                label: trans('common.dow_long.mon'),
                selected: false,
                timeslots: []
            },
            tue: {
                id: 'tue',
                label: trans('common.dow_long.tue'),
                selected: false,
                timeslots: []
            },
            wed: {
                id: 'wed',
                label: trans('common.dow_long.wed'),
                selected: false,
                timeslots: []
            },
            thu: {
                id: 'thu',
                label: trans('common.dow_long.thu'),
                selected: false,
                timeslots: []
            },
            fri: {
                id: 'fri',
                label: trans('common.dow_long.fri'),
                selected: false,
                timeslots: []
            },
            sat: {
                id: 'sat',
                label: trans('common.dow_long.sat'),
                selected: false,
                timeslots: []
            },
            sun: {
                id: 'sun',
                label: trans('common.dow_long.sun'),
                selected: false,
                timeslots: []
            }
        }
    }
    model.value.timeSlots.push(daysTemplate);
}

if (model.value.timeSlots.length === 0) {

    addDaySlot();
}
</script>

<template>
    <div class="-mt-6">
        <div class="border max-md:hidden rounded-xl  dark:border-neutral-700 transition-all"
             :class="{'ring-2 ring-offset-2':selectedPlan !== 'default'}">
            <plan-calendar v-model="model.timeSlots" v-model:plan="selectedPlan"
                           v-model:selected-worker="selectedWorker" v-model:deleted="deleted">
                <template #buttons>
                    <slot name="buttons"></slot>
                </template>
            </plan-calendar>

            <transition :name="animationName" mode="out-in">
                <div
                    :key="computedSelected"
                    :class="model.timeSlots[computedSelected].type === 'vacation' ? 'blur' : ''"
                >
                    <calendar-based-time-slot
                        :form-type="model.selectedType"
                        v-model:form="model"
                        v-model="model.timeSlots[computedSelected]"
                        v-model:selected-worker="selectedWorker"
                    ></calendar-based-time-slot>
                </div>
            </transition>
        </div>
        <div class="md:hidden">
            <edit-time-slot-component v-model="model.timeSlots" v-model:selected-worker="selectedWorker"
                                      v-model:deleted="deleted"></edit-time-slot-component>
        </div>
    </div>
</template>

<style scoped lang="scss">
.slide-left-enter-active, .slide-left-leave-active {
    transition: all 0.2s ease;
}

.slide-left-enter-from {
    transform: translateX(20%);
    opacity: 0;
}

.slide-left-leave-to {
    transform: translateX(-20%);
    opacity: 0;
}

.slide-right-enter-active, .slide-right-leave-active {
    transition: all 0.2s ease;
}

.slide-right-enter-from {
    transform: translateX(-20%);
    opacity: 0;
}

.slide-right-leave-to {
    transform: translateX(20%);
    opacity: 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
